import React, { useState, useEffect } from 'react';

const Zoom = ({ value = 200, onChange, onChangeStart, onChangeEnd, disabled = false }) => {
  const [zoom, setZoom] = useState(value);
  const [isDragging, setIsDragging] = useState(false);

  // Globaler MouseUp-Event-Listener
  useEffect(() => {
    const handleGlobalMouseUp = () => {
      if (isDragging) {
        setIsDragging(false);
        if (onChangeEnd) {
          onChangeEnd(zoom);
        }
      }
    };

    if (isDragging) {
      document.addEventListener('mouseup', handleGlobalMouseUp);
      return () => {
        document.removeEventListener('mouseup', handleGlobalMouseUp);
      };
    }
  }, [isDragging, zoom, onChangeEnd]);

  const handleChange = (e) => {
    if (disabled) return;
    const newValue = parseInt(e.target.value);
    setZoom(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleMouseDown = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    setIsDragging(true);
    if (onChangeStart) {
      onChangeStart();
    }
  };

  const handleMouseUp = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (isDragging) {
      setIsDragging(false);
      if (onChangeEnd) {
        onChangeEnd(zoom);
      }
    }
  };

  const handleWheel = (e) => {
    if (disabled) return;
    e.preventDefault();
    const delta = e.deltaY > 0 ? -10 : 10;
    const newValue = Math.max(100, Math.min(400, zoom + delta));
    
    if (newValue !== zoom) {
      setZoom(newValue);
      if (onChange) {
        onChange(newValue);
      }
      // Bei Mausrad sofort onChangeEnd aufrufen (kein Dragging)
      if (onChangeEnd) {
        onChangeEnd(newValue);
      }
    }
  };

  return (
    <div style={{ marginTop: 16, padding: '0 5px', opacity: disabled ? 0.5 : 1 }}>
      <label style={{ 
        display: 'block', 
        marginBottom: '8px', 
        fontSize: '14px', 
        fontWeight: '500',
        color: disabled ? '#999' : '#333'
      }}>
        Zoom {disabled && '(Öffne InfoPanels schließen)'}
      </label>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <input
          type="range"
          min="100"
          max="400"
          value={zoom}
          onChange={handleChange}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onWheel={handleWheel}
          disabled={disabled}
          style={{
            flex: 1,
            height: '6px',
            borderRadius: '3px',
            background: disabled ? '#ccc' : '#ddd',
            outline: 'none',
            cursor: disabled ? 'not-allowed' : 'pointer',
            pointerEvents: disabled ? 'none' : 'auto'
          }}
        />
        <span style={{ 
          fontSize: '14px', 
          fontWeight: '500',
          minWidth: '45px',
          textAlign: 'center',
          color: '#555'
        }}>
          {zoom}px
        </span>
      </div>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        fontSize: '12px', 
        color: '#666',
        marginTop: '4px'
      }}>
        <span>100px</span>
        <span>400px</span>
      </div>
    </div>
  );
};

export default Zoom;